/**
 * 商品基础信息登录 api
 */
import Vue from "vue";
import axios from '@/utils/http';
import axiosExample from 'axios';
const api = {

  //商品基础信息登录-获取dpt集合 根据编码类别
  dptsByItemFlg(_itemFlg) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/itembl/dpt`, {
      mask:false,
      params: {
        itemFlg:_itemFlg
      }
    });
  },
  //获取店内码类型的商品编码 item1
  createcode(_param) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/itembl/createcode`, {
      mask:false,
      params: _param
    });
  },

  //商品基础信息登录-商品基础信息登录
  add(params) {
    return axios.put(`${Vue.prototype.$base.API_PATH}/itembl/update`,params);
  }

}

export default api;



// WEBPACK FOOTER //
// ./src/api/itembl.js